const logo = require('../images/logo2.png')

export default logo;